module.exports = {
    NODE_ENV: "production",
    baseUrl: 'http://121.239.169.30:13001',
    // baseUrl: 'http://192.168.0.52:13001',
}